import { render, staticRenderFns } from "./mvp.vue?vue&type=template&id=d6d872fa&scoped=true&"
import script from "./mvp.vue?vue&type=script&lang=js&"
export * from "./mvp.vue?vue&type=script&lang=js&"
import style0 from "./mvp.vue?vue&type=style&index=0&id=d6d872fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d872fa",
  null
  
)

export default component.exports